// Model
import { Model } from "@mgs/ci2019-common/src/models/model/Model";
import { CatalogSelectionResultDTO } from "./CatalogSelectionResultDTO";
import { CatalogEntry } from "./CatalogEntry";

export class CatalogSelectionResult extends Model<CatalogSelectionResultDTO> {
  public klasse!: number;
  public entries!: CatalogEntry[];

  constructor(initial?: Partial<CatalogSelectionResultDTO>) {
    super();
    this.init(initial);
  }
}
